<template>
  <div>
    <b-row>
      <b-col
        cols="auto"
        md="auto"
        class="px-1 d-flex align-items-center justify-content-end color_second"
      >
        <!-- show out buttons -->
        <div class="d-flex">
          <slot name="buttons" />
        </div>
        <b-form-select
          v-if="hasSelectPerPage"
          v-b-tooltip.hover
          title="تعداد رکورد در هر صفحه"
          :plain="true"
          :options="perPageOptions"
          v-model="perPage"
          size="sm"
          class="p-1 w-auto mx-1"
          @change="handleSelectPerPage"
        />
      </b-col>
      <b-col
        cols="auto"
        md="auto"
        class="px-1 d-md-flex d-none align-items-center justify-content-end color_second"
      >
        <span v-for="(button, index) in buttons" :key="index">
          <b-button
            v-b-tooltip.hover
            :title="button.title"
            size="sm"
            class="btn-lightgray mx-1 color_second position-relative"
            @click="button.click"
          >
            <b-badge
              v-if="pathOr(false, ['badgeCondition'], button)"
              :variant="pathOr('danger', ['badgeVariant'], button)"
              pill
              class="position-badge"
              v-text="pathOr(null, ['badgeText'], button)"
            />
            <div class="d-flex align-items-center justify-content-between">
              <mdicon
                v-if="loading[pathOr(null, ['name'], button)] || button.loading"
                name="loading"
                size="24"
                class="spinner center"
              />
              <small
                v-if="pathOr(false, ['text'], button)"
                class="mr-2 font-weight-bold"
                v-text="pathOr('', ['text'], button)"
              />
              <mdicon
                v-if="
                  !loading[pathOr(false, ['name'], button)] && !button.loading
                "
                :name="button.iconName"
                size="24"
              />
            </div>
          </b-button>
        </span>
      </b-col>
      <b-col cols="auto" md="auto" class="px-1 d-block d-md-none">
        <b-dropdown
          variant="primary"
          left
          class="mr-1"
          menu-class="base_button__menu"
        >
          <template slot="button-content">
            <mdicon name="menu" size="20" />
          </template>
          <b-dropdown-item
            v-for="(button, index) in buttons"
            :key="index"
            class="w-100"
          >
            <b-button
              block
              size="sm"
              class="btn-lightgray mx-1 color_second d-flex align-items-center position-relative"
              @click="button.click"
            >
              <b-badge
                v-if="pathOr(false, ['badgeCondition'], button)"
                :variant="pathOr('', ['badgeVariant'], button)"
                pill
                class="position-badge"
                v-text="pathOr(null, ['badgeText'], button)"
              />
              <mdicon
                v-if="loading[pathOr(null, ['name'], button)]"
                name="loading"
                size="24"
                class="spinner center"
              />
              <mdicon v-else :name="button.iconName" size="24" />
              <small class="ml-2 font-weight-bold" v-text="button.title" />
            </b-button>
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>

    <FilterBox
      v-if="showFilter"
      ref="filterBox"
      :headers="filterHeaders"
      @getFilterItems="getFilterItems"
      @getFilterDate="getFilterDate"
      @closeAdvanceFilter="handleFilter"
    />
  </div>
</template>

<script>
import FilterBox from "@/components/global/FilterBox";
import { pathOr, includes } from "ramda";
import { isAdmin, generateApiUrl, getWord } from "@/shared/utils";

export default {
  name: "base-buttons",
  components: {
    FilterBox,
  },
  props: {
    permissions: {
      type: Array,
      default: () => [],
    },
    resourceKey: {
      type: String,
      default: null,
    },
    defaultViewCount: {
      type: Number,
      default: null,
    },
    paramsData: {
      type: Object,
      default: null,
    },
    filterHeaders: {
      type: Array,
      default: () => [],
    },
    url: {
      type: String,
      default: "",
    },
    uploadExcelTooltip: {
      type: String,
      default: "",
    },
    hasSelectPerPage: {
      type: Boolean,
      default: true,
    },
    hasHiddenFields: {
      type: Boolean,
      default: true,
    },
    hasUploadExcel: {
      type: Boolean,
      default: true,
    },
    hasExportExcel: {
      type: Boolean,
      default: true,
    },
    hasRefresh: {
      type: Boolean,
      default: true,
    },
    hasFilterCache: {
      type: Boolean,
      default: true,
    },
    hasFilter: {
      type: Boolean,
      default: true,
    },
    hasAdd: {
      type: Boolean,
      default: true,
    },
    extraButtons: {
      type: Array,
      default: () => [],
    },
    otherExportExcelParams: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      perPage: 10,
      perPageOptions: [5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      showFilter: false,
      paramsPage: {},
      page: 1,
      loading: {
        exportExcel: false,
        refresh: false,
        deleteFilterCache: false,
        default: false,
      },
    };
  },
  computed: {
    buttons() {
      const { order_by, ...paramsDataWithoutOrderby } = this.paramsData;
      const buttonsArr = [
        ...this.extraButtons,
        {
          name: "hiddenFields",
          condition: this.hasHiddenFields,
          title: "تنظیمات ستون‌های جدول",
          click: this.handleHiddenFields,
          iconName: "table-cog",
        },
        {
          name: "uploadExcel",
          condition:
            this.hasUploadExcel && isAdmin(this.permissions, ["admin"]),
          title: this.uploadExcelTooltip,
          click: this.handleUploadExcel,
          iconName: "cloud-upload-outline",
        },
        {
          name: "exportExcel",
          condition: this.hasExportExcel && isAdmin(this.permissions),
          title: "ساختن خروجی اکسل",
          click: this.handleExportExcel,
          iconName: "microsoft-excel",
        },
        {
          name: "refresh",
          condition: this.hasRefresh,
          title: "به‌روز رسانی لیست",
          click: this.handleRefresh,
          iconName: "refresh",
        },
        {
          name: "deleteFilterCache",
          condition: this.hasFilterCache,
          title: "حذف فیلترها",
          click: this.deleteFilterCacheResource,
          iconName: "filter-remove-outline",
        },
        {
          name: "filter",
          condition: this.hasFilter,
          title: "فیلترهای جستجو",
          click: this.handleFilter,
          iconName: "filter-outline",
          badgeCondition: Object.keys(paramsDataWithoutOrderby).length,
          badgeText: Object.keys(paramsDataWithoutOrderby).length,
          badgeVariant: "danger",
        },
        {
          name: "add",
          condition: this.hasAdd && isAdmin(this.permissions, ["admin"]),
          title: "اضافه کردن",
          click: this.handleAdd,
          iconName: "plus",
        },
      ];
      return buttonsArr.filter((button) => button.condition);
    },
  },
  watch: {
    defaultViewCount: {
      immediate: true,
      handler(value) {
        this.perPage = value || this.perPage;
      },
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    generateApiUrl,
    getWord,
    handleSelectPerPage(value) {
      this.$emit("handleSelectPerPage", value);
    },
    handleHiddenFields() {
      this.$emit("handleHiddenFields");
    },
    handleUploadExcel() {
      this.$emit("handleUploadExcel");
    },
    async handleExportExcel() {
      if (!this.hasExportExcel || this.loading.exportExcel) return;
      try {
        this.loading.exportExcel = true;
        const url = generateApiUrl(
          ["resources", "exportData"],
          [this.resourceKey]
        );
        const payload = {
          filters: { ...this.paramsData, ...this.otherExportExcelParams },
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading.exportExcel = false;
      }
    },
    handleRefresh() {
      if (this.loading.refresh) return;
      this.loading.refresh = true;
      this.$emit("handleRefresh", () => {
        this.loading.refresh = false;
      });
    },
    handleFilter() {
      this.showFilter = !this.showFilter;
    },
    handleAdd() {
      this.$emit("handleAdd");
    },
    /* filter methods */
    resetParamsPage() {
      this.paramsPage = { page: 1, per_page: this.perPage };
    },
    fetchData() {
      this.$emit("fetchData");
    },
    getUrlResource() {
      const resource = this.url
        .split(this.$config.api_url)
        .filter((el) => el != "")[0]
        .split("?")[0];
      return resource || null;
    },
    async deleteFilterCacheResource() {
      if (this.loading.deleteFilterCache) return;
      try {
        this.loading.deleteFilterCache = true;
        const resource = this.getUrlResource();
        const url = generateApiUrl(["resources", "filter_cache_resource"]);
        const payload = { resource };
        const response = await this.$httpService.delete(url, payload);
        this.$notify.success(response.data.message);
        this.showFilter = false;
        this.resetParamsPage();
        this.$emit("getParamsPage", this.paramsPage);
        this.fetchData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading.deleteFilterCache = false;
      }
    },
    getFilterItems(value, key) {
      if (includes(typeof value, ["string", "number"]) && value !== "") {
        this.paramsPage[key] = value;
      } else if (includes(typeof value, ["object"]) && value.length) {
        this.paramsPage[key] = value;
      } else {
        delete this.paramsPage[key];
      }
      this.page = 1;
      this.paramsPage["page"] = 1;
      this.paramsPage["per_page"] = this.perPage;
      this.$emit("getParamsPage", this.paramsPage);
      this.fetchData();
    },
    getFilterDate(key, type, from, to) {
      if (to && from) {
        this.paramsPage[key] = [type, from, to];
      } else if (from) {
        this.paramsPage[key] = [type, from];
      } else {
        delete this.paramsPage[key];
      }
      this.paramsPage["page"] = 1;
      this.page = 1;
      this.$emit("getParamsPage", this.paramsPage);
      this.fetchData();
    },
  },
};
</script>

<style lang="scss" scoped>
.advance_filter {
  height: 100vh;
  left: -5px;
  top: 47px;
}
</style>
